import { useState } from 'react';
import { lookupCompanyByWebsite} from '../infrastructure/company-lookup-service';
import { OrganizationFormData } from '../entities/Organization';

export const useCompanyLookup = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCompanyDetails = async (websiteUrl: string): Promise<OrganizationFormData | null> => {
    setIsLoading(true);
    setError(null);

    try {
      const data = await lookupCompanyByWebsite(websiteUrl);
      return data;
    } catch (_err) {
      setError('Failed to fetch company details');
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { fetchCompanyDetails, isLoading, error };
};
